import React, { useState } from "react";
// import Loader from "../../Loader";
import cx from "classnames";
import "./style.scss";

const BUTTON_DEFAULT_RIGHT_OFFSET = 48;

const GridFloatingButton = ({ onGridFloatingButtonClick, floatingButtonLeftOffset }) => {
    const [isLoading, setIsLoading] = useState(false);
    function handleClick() {
        if (
            typeof onGridFloatingButtonClick === "object" &&
            onGridFloatingButtonClick.asyncHandler &&
            typeof onGridFloatingButtonClick.asyncHandler === "function"
        ) {
            const { asyncHandler } = onGridFloatingButtonClick;
            if (asyncHandler) {
                setIsLoading(true);
                asyncHandler().finally(() => {
                    setIsLoading(false);
                });
            }
        } else {
            onGridFloatingButtonClick();
        }
    }

    const style = floatingButtonLeftOffset ? {right: `${BUTTON_DEFAULT_RIGHT_OFFSET + floatingButtonLeftOffset}px`} : {}

    return (
        <button
            className={cx("grid-floating-button", { disabled: isLoading })}
            style={style}
            disabled={isLoading}
            onClick={handleClick}
        >
            {/* +{isLoading && <Loader />} */}
            +
        </button>
    );
};

export default GridFloatingButton;
